export const ANTI_BOT_PROVIDERS = {
  RECAPTCHA_V3: "RECAPTCHA_V3",
} as const;

export type AntiBotProviderType =
  (typeof ANTI_BOT_PROVIDERS)[keyof typeof ANTI_BOT_PROVIDERS];

export interface AntiBotMeta {
  provider: AntiBotProviderType;
  publicConfig: Record<string, unknown> | null;
}

export const DEFAULT_ANTI_BOT_PROVIDER: AntiBotProviderType = ANTI_BOT_PROVIDERS.RECAPTCHA_V3;

export const resolveAntiBotMeta = (
  metaAntiBot?: AntiBotMeta | null,
): AntiBotMeta | null => {
  const siteKey = metaAntiBot?.publicConfig?.siteKey;
  if (metaAntiBot && typeof siteKey === "string" && siteKey !== "") {
    return metaAntiBot;
  }

  const globalSiteKey = process.env.NEXT_PUBLIC_RECAPTCHA_GLOBAL_SITE_KEY;
  if (globalSiteKey) {
    return {
      provider: DEFAULT_ANTI_BOT_PROVIDER,
      publicConfig: { siteKey: globalSiteKey },
    };
  }

  return null;
};
